import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=3c8fe937&scoped=true"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"
import style0 from "./Connect.vue?vue&type=style&index=0&id=3c8fe937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fe937",
  null
  
)

export default component.exports